import Echo from "laravel-echo";
import { getFromLocalStorage } from "@/utils/localstorage";

let echo = null;
const token = getFromLocalStorage("authtoken", null);

if (
  process.env.VUE_APP_WS_ENABLE === "true" &&
  !(window.location !== window.parent.location)
) {
  window.Pusher = require("pusher-js");

  echo = new Echo({
    broadcaster: "pusher",
    key: process.env.VUE_APP_WS_KEY,
    wsHost: process.env.VUE_APP_WS_HOST,
    cluster: process.env.VUE_APP_WS_CLUSTER,
    wsPort: process.env.VUE_APP_WS_PORT,
    forceTLS: false,
    disableStats: false,
    encrypted: true,
    authEndpoint: process.env.VUE_APP_WS_AUTH_ENDPOINT,
    auth: {
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    },
  });
}

export default echo;
